import {User, UserStatus} from '../types';

// How a person signs in, in users-api terms (FNP-1045 §5.2).
//
// Staff who sign in through the platform sign-in appear in the main pool as
// FEDERATED users: status EXTERNAL_PROVIDER, username prefixed with the
// provider ("openidconnectprovider_..." for the platform sign-in, "google_..."
// for Google, read from the dev pool on 2026-10-13). Their password and MFA live
// with that provider, so Directory offers no password, MFA or enable/disable
// action for them and says who manages their sign-in instead.
export const isFederated = (user: User) => user.status === UserStatus.EXTERNAL_PROVIDER;

const PROVIDER_LABELS: Record<string, string> = {
    openidconnectprovider: 'the platform sign-in',
    google: 'Google',
};

export const signInManagedBy = (user: User): string | undefined => {
    if (!isFederated(user)) {
        return undefined;
    }
    const provider = (user.username ?? '').split('_')[0].toLowerCase();
    return PROVIDER_LABELS[provider] ?? 'an external sign-in';
};
